import React from "react";
import { Store } from "lucide-react";

export const StoresStrip = ({ stores }) => {
    if (!stores || stores.length === 0) return null;
    return (
        <section className="border-b-2 border-black bg-black text-[#CCFF00]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center gap-x-8 gap-y-3 justify-center font-display text-xl md:text-2xl font-black uppercase tracking-tighter">
                <Store className="w-5 h-5" />
                {stores.map((s, i) => (
                    <span key={s.id} className="inline-flex items-center gap-2">
                        {s.name}
                        {i < stores.length - 1 && <span className="text-[#CCFF00]/40">·</span>}
                    </span>
                ))}
            </div>
        </section>
    );
};
